module.exports = __webpack_public_path__ + "img/00004.66151032.webp";